import { isMobile } from '../../utils';
export var viewModalOnMobile = {
  name: 'viewModalOnMobile',
  enabled: true,
  phase: 'beforeWrite',
  fn: function fn(_ref) {
    var state = _ref.state;
    if (isMobile()) {
      state.styles.popper = {
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        transform: 'none'
      };
    }
  }
};
//# sourceMappingURL=modifiers.js.map